var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.errors
        ? _c("api-errors", { attrs: { errors: _vm.errors } })
        : _vm._e(),
      _vm._v(" "),
      _vm.mutableFavouriteInfo.exists
        ? _c(
            "a",
            {
              on: {
                click: function ($event) {
                  return _vm.deleteFavourite(_vm.mutableFavouriteInfo.id)
                },
              },
            },
            [
              _vm.loadingDelete
                ? _c("i", {
                    staticClass: "fa fa-spinner fa-spin text-center",
                    attrs: { "aria-hidden": "true" },
                  })
                : _c("i", {
                    staticClass: "fa fa-bookmark fa-fw",
                    attrs: { title: "Remove from my favourite items" },
                  }),
            ]
          )
        : _c(
            "a",
            {
              on: {
                click: function ($event) {
                  return _vm.createFavourite()
                },
              },
            },
            [
              _vm.loadingCreate
                ? _c("i", {
                    staticClass: "fa fa-spinner fa-spin text-center",
                    attrs: { "aria-hidden": "true" },
                  })
                : _c("i", {
                    staticClass: "fa fa-bookmark-o fa-fw",
                    attrs: { title: "Add to my favourite items" },
                  }),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }